<sm-title-bar [headerCustomTemplate]="addButton" [backWithAllParams]="true" pageTitle="Available employee pack" *ngIf="!loader">
  <ng-template #addButton>
    <div class="create_btn_sd">
      <button mat-flat-button color="primary" (click)="onnewpackadd()">
          <mat-icon>add</mat-icon> 
          Buy new pack
      </button>
  </div>
  </ng-template>
</sm-title-bar>
<div class="" *ngIf="!loader && employeeSubscriptionHistoryData.length > 0">
  <div class="row">
    <div class="col-sm-4" *ngFor="let item of employeeSubscriptionHistoryData">

    <div class="packs">
      <mat-card>
        <div class="pack" >
            <div class="card_header">
                <h2>{{item.planName}}</h2>
                <p style="color: #000;">{{item.planDescription}}</p>

            </div>
            <div class="card_subheader">
                <p class="purchase-date">Purchased on {{item.creationDate | date}}</p>
                <p class="validity">{{item.validity}} days validity</p>

            </div>
            <button (click)="createEmployee(item)">Select Pack</button>
        </div>
      </mat-card>

    </div>
  
</div>
</div>
</div>
